import Joi from 'joi';

import {
  tenantContactCompanyNameOptional,
  tenantContactUpdateIdRule,
  tenantContactWriteFields,
} from '../../../../shared/modules/contacts/validators/schemas/tenant-contact-write-fields.schema';

/**
 * Schema for contact validation when updating an existing location contact.
 */
export const updateLocationContactSchema = () =>
  Joi.object({
    ...tenantContactUpdateIdRule(),
    ...tenantContactCompanyNameOptional(),
    ...tenantContactWriteFields(),
  }).unknown();
